import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OE_CheckinOTP.html?raw';
import { DateHelpers, UrlHelpers } from "../../more/Helpers";



interface OTPconfiguration {
    OtpInterval: number,
    SecretValidUntil: Date,
    SharedSecret: string
    OtpList: Array<otpValue>
}

interface otpValue {
    value: string,
    expirationDate: Date
}

class OE_CheckinOTP extends compose(_WidgetBaseSP) {
    templateString: any = template;



    private _GUIDtimeStamp: Date;
    private _GUID: string;
    private evBookingID: string;

    private _OTPrequestIntervalHandle: any = null;
    private _OTPIntervalHandle: any = null;
    private _progressIntervalHandle: any = null;

    private OTPconfig: OTPconfiguration;


    private progressNode: HTMLElement;
    private txtOTP: HTMLElement;
    private txtProgress: HTMLElement;
    private txtConfig: HTMLElement;

    private getOtpConfiguration() {
        this.StandbyStart();

        let data = {
            "key": this.evBookingID
        };

        this.RequestManager.callfunction(
            "Webtool_API_OECheckinTerminal__GetTOTPconfig", //Webtool_TOTP__GetBaseConfigJSON",
            data,
            lang.hitch(this, this._onGetOtpConfigurationResponse),
            lang.hitch(this, this._onGetOtpConfigurationError)
        )
    }

    private _onGetOtpConfigurationResponse(response: OTPconfiguration) {
        this.StandbyStop();

        if (!response) {
            alert("no configuration received!");
            return;
        }

        this.OTPconfig = response;

        //this._OTPIntervalHandle = setInterval(lang.hitch(this, this._showCurrentOtp), 500);
        this._showCurrentOtp();

        this.startOtpRequestInterval();

        this.txtConfig.innerHTML = JSON.stringify(response);


    }

    private _onGetOtpConfigurationError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }
    private startOtpRequestInterval() {
        if (this._OTPrequestIntervalHandle) {
            clearInterval(this._OTPrequestIntervalHandle);
        }

        let actualInterval = this.OTPconfig.OtpInterval;
        if (this.OTPconfig.OtpList?.length >= 2) {
            actualInterval = this.OTPconfig.OtpInterval * (this.OTPconfig.OtpList.length - 1);
        }

        this._OTPrequestIntervalHandle = setInterval(lang.hitch(this, this._renewOtp), actualInterval * 1000);

        //setInterval(lang.hitch(this, this._updateProgress), 1500);
    }

    private _renewOtp() {

        this.hourGlassStart(this.txtConfig);

        let data = {
            "key": this.evBookingID
        };

        this.RequestManager.callfunction(
            "Webtool_API_OECheckinTerminal__GetTOTPconfig", //Webtool_TOTP__GetBaseConfigJSON",
            data,
            lang.hitch(this, this._onNewOtpResponse),
            lang.hitch(this, this._onNewOtpError)
        )
    }

    private _onNewOtpResponse(response: OTPconfiguration) {
        this.hourGlassEnd(this.txtConfig);
        this.OTPconfig = response;
        this.txtConfig.innerHTML = JSON.stringify(response);

        if (this._OTPIntervalHandle) {
            clearInterval(this._OTPIntervalHandle);
        }

        //this._OTPIntervalHandle = setInterval(lang.hitch(this, this._showCurrentOtp), 500);
        this._showCurrentOtp();

    }

    private _onNewOtpError(error: more.requestErrorMessage) {
        // nochmal!
        setTimeout(lang.hitch(this, this._renewOtp), 2000);
    }

    private _currentOtp: otpValue;
    private _showCurrentOtp() {
        this.disableNode(this.txtOTP);
        let now = new Date().valueOf();


        for (let otp of this.OTPconfig?.OtpList) {
            let otpExpirationValue = otp.expirationDate.valueOf();
            if (otpExpirationValue > now) {
                this._currentOtp = otp;
                this.disableNode(this.txtOTP, false);
                this.txtOTP.innerHTML = otp.value;

                this.previousProgress = null;   

                let diffmSeconds = (otpExpirationValue - now); //

                setTimeout(lang.hitch(this, this._showCurrentOtp), diffmSeconds + 100);
                this._updateProgress();

                break;
            }
        }
    }

    private previousProgress: number;
    private _updateProgress() {
        let otp: otpValue = this._currentOtp;
        let otpExpirationValue = otp.expirationDate.valueOf();

        let now = new Date().valueOf();

        let diffSeconds = (otpExpirationValue - now) / 1000; //
        

        // Intervall = 100%
        // diffSeconds = x

        let currentProgress = (diffSeconds * 100) / this.OTPconfig.OtpInterval;

        if (!this.previousProgress || this.previousProgress < currentProgress) {
            
            this.progressNode.style.setProperty("--startProgress", currentProgress.toFixed(1) + "%");

            // die Dauer bei 100% ist das Intervall
            // bei weniger entsprechend runtermultiplizieren:
            let durationStr = (this.OTPconfig.OtpInterval * (currentProgress / 100)).toFixed(1) + "s";
            this.progressNode.style.setProperty("--duration", durationStr);

            this.progressNode.style.animation = 'none';
            this.progressNode.offsetHeight; /* trigger reflow */
            this.progressNode.style.animation = null; 


            this.progressNode.style.setProperty("animation-play-state", "running");

        }

        this.previousProgress = currentProgress;        
        //this.txtProgress.innerHTML = currentProgress.toString();
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        let evbooking = UrlHelpers.getUrlParameterValue("evb");
        this.evBookingID = evbooking ? evbooking : null;

        let value = UrlHelpers.getUrlParameterValue("guid");

        if (!value) {
            alert("link wrong! no guid??");
        } else {
            this._GUID = value;
            this._GUIDtimeStamp = new Date();
        }
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.getOtpConfiguration();
    }
}

export default mdsWidget(OE_CheckinOTP);